/**
 * /tenants/$slug/authentication/sign-in/recovery — the recovery order and the
 * support contact shown when a recovery step fails.
 */

import { createFileRoute } from "@tanstack/react-router";
import { queryKeys } from "@/lib/query-keys";
import { fetchCascadePolicy } from "@/features/cascade-policy/queries";
import { microcopyQueryOptions } from "@/features/microcopy/queries";
import { tenantCapabilities } from "@/features/tenants/capabilities";
import { signInAvailability } from "@/features/signin-settings/sections";
import { RecoverySection } from "@/features/signin-settings/pages/recovery-section";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in/recovery")({
  loader: ({ context }) => {
    const tenant = context.settingsTenant;
    const av = signInAvailability(tenant, tenantCapabilities(tenant), () => true);
    return Promise.all([
      context.queryClient.ensureQueryData({
        queryKey: queryKeys.cascadePolicy.policy(context.tenant.id),
        queryFn: () => fetchCascadePolicy(context.tenant.id),
      }),
      av.recovery.supportWording ? context.queryClient.prefetchQuery(microcopyQueryOptions(tenant.id)) : undefined,
    ]);
  },
  component: RecoverySection,
});
